<template>
    <table class="table table-hover table-sm">
        <thead v-if="false">
            <tr>
                <td colspan="5">
                    <div class="form-check form-check-inline" v-for="brand in brands" v-bind:key="brand">
                        <input class="form-check-input" type="checkbox" :id="brand" :value="brand">
                        <label class="form-check-label" :for="brand">
                            {{brand}}
                            <span style="color: lightgrey">({{brandCounts[brand]}})</span>
                        </label>
                    </div>
                </td>
            </tr>
        </thead>
        <thead>
            <tr>
                <th></th>
                <th>Toode</th>
                <th>Müüja</th>
                <th class="text-right">Minimaalne hind</th>
                <th></th>
            </tr>
        </thead>
        <list-row
                v-for="item in items"
                v-bind:item="item"
                v-bind:key="item.id"
                v-bind:class="eq(searchTerm, item.code) ? 'table-primary' : ''"
                v-on:search="searchEvent"
                v-on:toCart="addToCart"
        ></list-row>
    </table>
</template>

<script>

    import ListRow from './ListRow';
    import { asciiOnly } from './../utils.js'

    export default {
        name: "List",
        components: {
            'list-row': ListRow,
        },
        data: function(){
            return {
            };
        },
        props: ['searchTerm'],
        methods: {
            addToCart: function(item) {
                this.$bvToast.toast('Kaup lisatud ostukorvi!', {
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 2000,
                    noCloseButton: true
                });
                this.$store.dispatch('cart/putCartItem', item);
                this.$store.dispatch('cart/incCartItem', item.id)
            },
            eq: function(l, r) {
                return asciiOnly(l).toUpperCase() === asciiOnly(r).toUpperCase();
            },
            searchEvent(searchTerm){
                this.$emit('search', searchTerm);
            },
        },
        computed: {
            items: function() {
                return this.$store.getters['list/items'];
            },
            brands: function(){
                return this.$store.getters['list/brands'];
            },
            brandCounts: function(){
                return this.$store.getters['list/brandCounts'];
            },
        }
    }
</script>

<style scoped>

</style>